import React from 'react';
import PropTypes from 'prop-types';

import { StepBarWrapper, Step, StepLabel, StepConnector } from './style';

const StepBar = ({ steps, currentStep }) => {
  return (
    <StepBarWrapper>
      {steps.map((step, index) => (
        <React.Fragment key={step.id}>
          {index > 0 && <StepConnector />}
          <Step>
            <StepLabel
              active={step.id === currentStep}
              completed={step.id < currentStep}
            >
              {`${step.id}. ${step.title}`}
            </StepLabel>
          </Step>
        </React.Fragment>
      ))}
    </StepBarWrapper>
  );
};

StepBar.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default StepBar;
